var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyprus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M16.5 6.965h-1.035a3.465 3.465 0 01-6.93 0H7.5a4.5 4.5 0 003.27 4.328 1.17 1.17 0 00.12 1.26l1.11-.908 1.133.908a1.141 1.141 0 00.112-1.268 4.5 4.5 0 003.255-4.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.232 6.62a1.687 1.687 0 001.725 1.725l.353.353H12s.345-1.043 1.035-1.043a.675.675 0 01.697-.69h1.035s-.345-1.387 1.388-2.422l-.698-.345s-2.422 1.725-4.147 1.38v.69h-.698l-.345-.345-1.035.697z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyprus);
export default __webpack_public_path__ + "static/media/Cyprus.a3631fe27dce10e7dc5e2f7d41f6e07a.svg";
export { ForwardRef as ReactComponent };